var _radialGradient, _path, _g, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 128 128",
    viewBox: "0 0 128 128",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 63.8872,
    cy: 74.9249,
    gradientTransform: "matrix(1 0 0 1.0839 0 -6.2898)",
    gradientUnits: "userSpaceOnUse",
    r: 64.9356
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3956,
    stopColor: "#e1e7ea"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9934,
    stopColor: "#d6e1e6"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m111.79 67.58c.57-3.41 2.93-15.55.78-27.47-1.37-7.59-6.11-17.5-11.4-22.51-10.21-9.67-24.43-13.6-37.51-13.6s-26.59 3.93-36.8 13.6c-5.29 5.01-10.03 14.93-11.4 22.51-2.15 11.92.21 24.06.78 27.47.77 4.65-1.27 9.79-1.67 14.42-.43 5.04 1.95 8.95 6.21 11.72 3.55 2.31 7.69 3.53 11.53 5.32 4.57 2.13.42 9.82 2.11 13.7.85 1.96 2.71 3.31 4.63 4.26 2.44 1.22 5.25 1.98 7.9 1.31-.4.1.76 2.43 2.29 3.38 1.4.86 3.13 1.74 4.74 2.09 3.2.7 6.37-.48 8.35-1.5 1.08-.56 2.34-.56 3.41 0 1.98 1.02 5.15 2.2 8.35 1.5 2.41-.53 4.56-1.96 6.1-3.83.72-.88 1.84-1.36 2.97-1.28 3.36.22 8.5-1.15 10.73-6.22 1.25-2.82-.01-6.14.82-9.09 1.41-5 6.33-6.24 10.29-8.57 5.25-3.08 8.35-6.53 8.49-11.39.14-5.16-2.36-11.83-1.7-15.82z",
    fill: "url(#a)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#424242"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.83,
    cy: 64.15,
    rx: 13.74,
    ry: 12.49,
    transform: "matrix(.2588 -.9659 .9659 .2588 -32.4418 86.0203)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 88.2,
    cy: 64.15,
    rx: 12.49,
    ry: 13.74,
    transform: "matrix(.9659 -.2588 .2588 .9659 -13.598 25.0125)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m55.98 86.71c0-4.43 3.59-15.41 8.03-15.41s8.03 10.97 8.03 15.41c0 9.01-8.03 2.87-8.03 2.87s-8.03 6.66-8.03-2.87z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m42.63 118.43c-1.2-.23-2.34-.6-3.36-1.35.85-.2 1.7-.42 2.48-.8 1.94-.97 1.89-2.53 2.32-4.45.37-1.68.73-3.36 1.16-5.03.29-1.12 1.03-2.19 2.18-2.03 1.44.2 1.58 1.22 1.34 2.77-.23 1.44-1.97 10.93-1.97 10.94-.08.43-2.97.14-3.25.1-.3-.04-.6-.09-.9-.15z",
    fill: "#8abfd1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m86.04 118.43c1.2-.23 2.34-.6 3.36-1.35-.85-.2-1.7-.42-2.48-.8-1.94-.97-1.89-2.53-2.32-4.45-.37-1.68-.73-3.36-1.16-5.03-.29-1.12-1.03-2.19-2.18-2.03-1.44.2-1.58 1.22-1.34 2.77.23 1.44 1.97 10.93 1.97 10.94.08.43 2.97.14 3.25.1.3-.04.6-.09.9-.15z",
    fill: "#8abfd1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m59.47 123.45s2.27-3.06 2.35-5.15c.15-3.73.36-8.77.36-11.69 0-1.16.7-2.05 1.87-2.05 1.16 0 1.81.78 1.81 1.94 0 .05.27 6.83.27 11.55 0 2.18 2.44 5.39 2.44 5.39-1-.45-2.75-1.32-4.55-1.24-2.28.11-4.55 1.25-4.55 1.25z",
    fill: "#8abfd1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkull);
export default __webpack_public_path__ + "static/media/skull.1f65d4caa52b38e3cd15439742c6ec66.svg";
export { ForwardRef as ReactComponent };